<div class="dashboard mt-3">
  <div class="flex justify-between items-center">
    <div class="tab__container">
      <button *ngFor="let dashboard of dashboardsShow" class="tab"
        [ngClass]="{ 'tab--active': activeDash === dashboard.tabName }" (click)="changeDash(dashboard.tabName)">
        {{ dashboard.tabName }}
      </button>
    </div>
    <select class="w-60 form-select form-select-lg mr-5 text-white font-medium bg-blumine" aria-label=".form-select-lg"
      [(ngModel)]="companyId" (change)="changeTabsByCompanyId()">
      <option value="">Todas as Empresas</option>
      <option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</option>
    </select>
  </div>

  <!-- <div class="w-full flex justify-center items-center">
    <img [src]="activeImage" alt="Relatórios" />
  </div> -->
  <!-- monta apenas o iframe da aba ativa. evita carregar todos os embeds do metabase
       de uma vez (cada iframe que falha retenta e escreve storage/cookie -> trava o navegador). -->
  <ng-container *ngFor="let dashboard of dashboardsShow">
    <iframe *ngIf="activeDash === dashboard.tabName" [src]="sanitize(dashboard.metabaseUrl)" frameborder="0"
      allowtransparency (load)="load()"></iframe>
  </ng-container>
</div>
